/**
 * Created by neo on 29.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { ExploreEntry } from '../../Model/Explore/ExploreEntry';
import { useLocalized } from '../../Hooks/useLocalized';
import styled from '@emotion/styled';
import { Recipe } from '../../Model/Diet/Recipe/Recipe';

const Description = styled.p`
  color: black;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 1 line */
  -webkit-box-orient: vertical;
  flex-shrink: 0; /* Prevent shrinking */
`;

export type ExploreCardShortDescriptionProps = {
  entry: ExploreEntry | Recipe;
};

export const ExploreCardShortDescription: React.FC<ExploreCardShortDescriptionProps> = observer(({ entry }) => {
  const longDescription = useLocalized(entry.description).substring(0, 64);
  const localizedShortDescription = useLocalized((entry as ExploreEntry).shortDescription);
  const shortDescription =
    entry.type === 'recipe'
      ? `${Math.floor((entry as Recipe).nutrition?.nutrients.calories?.amount || 0)} kcal`
      : localizedShortDescription;
  const description = shortDescription || `${longDescription}...`;

  if (shortDescription || longDescription) {
    return <Description>{description}</Description>;
  }

  return null;
});
